import { Alert } from "reactstrap";
import { useTranslation } from "react-i18next";
import { CyPushNeededInfo } from "../CyPushNeededInfo";

/** Shown while changes wait in the offline queue; they are sent by themselves once the device is online. */
export function PushNeededInfo() {
  const { t } = useTranslation();
  return (
    <Alert color="warning" fade={false} data-cy={CyPushNeededInfo.Alert}>
      {t("playlist.edit.offlineChanges")}
    </Alert>
  );
}
